import { AuthActionScreen } from "@/interactors/AuthActionScreen";

export default function AuthAction() {
  return <AuthActionScreen />;
}
